// extracted by mini-css-extract-plugin
export default {"Menu":"bgu_a bhj_h","Menu__offsetParent":"bgu_b bhj_bj","Menu__trigger--shadowed":"bgu_c"};